export const AppConfig = {
  publicUrl: process.env.PUBLIC_URL,
  signListColumns:
    process.env.REACT_APP_SIGN_LIST_COLUMNS ??
    'division,date,number,customer,vehicleRegistrationNumber',
  languages: ['lt', 'lv', 'ee', 'en'], // lt and en is included by default
};
